module.exports = __webpack_public_path__ + "img/btn-ota-no.c54a86df.png";